import { enqueueSnackbar, getUserInfo } from 'actions';
import config from 'configuration/configuration.js';

import {
	GetOperatorsRequest,
	UpdateSettingsRequest,
	ChangePasswordRequest
} from '../requests/SettingsRequests.js';

export const GET_OPERATORS = 'GET_OPERATORS';
export const SET_FORM_STATE = 'SET_FORM_STATE';

const onGetOperators = (value) => ({
	type: GET_OPERATORS,
	operators: value
});

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const GetOperators = (userId) => async (dispatch) => {
	await GetOperatorsRequest(userId).then(response => {
		dispatch(onGetOperators(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const UpdateSettings = (data) => async (dispatch) => {
	await UpdateSettingsRequest(data).then(response => {
		dispatch(getUserInfo(localStorage.getItem(config.TOKEN_KEY)));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ChangePassword = (data) => async (dispatch) => {
	await ChangePasswordRequest(data).then(response => {
		dispatch(enqueueSnackbar({ message: 'Password changed!', options: { key: new Date().getTime() + Math.random(), variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
